import { FEATURES } from '@/config/featureConfig';

// LockInfo interface for menu items
interface LockInfo {
  requiredPackage: 'Professional' | 'Replenishment';
  benefits: string[];
  tooltipText?: string;
}

export const replenishmentV1 = {
    data: [
        {
          section: 'stocky-migration',
          title: 'Switching from Stocky',
          icon: 'mdi-swap-horizontal',
          type: 'group',
          items: [
            {
              title: 'Master Guide',
              icon: 'mdi-book-open-page-variant-outline',
              type: 'single',
              link: '/stocky-switcher',
            },
            {
              title: 'Stocky Migration Tool',
              icon: 'mdi-database-import-outline',
              type: 'single',
              link: '/stocky-data-migration',
            },
          ],
        },
        {
            section: 'demand-forecasting',
            title: 'Demand forecasting',
            items: [
                {
                title: 'Historical sales-based',
                type: 'single',
                icon: 'mdi-history',
                link: '/reports/38/historical-sales-based-forcasting/609?report_query=eJzNWG1v2zYQ_iuCgAEtZnWyHOXtm-s4RbHFzWwnwxAEAiPRjlaJ1PiSzgjy33ekJJOWHUvuMmxfBIh87u65O77c8dkVqciwe-5eUoZjxIWzkEIy7CQ4RyRxe278iJiYrwoFmt1cXQ2nv8PoI-IjNeGeCyZxz01SXmRodUUThRPoAZT2XI4zHAucjBBLRjSTOeHu-d2zS1CuYLeIpYgIZaSUe1oPJEigyqjAf6mRTKb8ChVFSpbuOZFZ9tJbK1qTn6EMc-dXCUpSsTKK7xYVIuIKEf1ZIe43TSU4TnOUNa25r0i7FoU5FShzbkgquDOjWWLZlmow4jAYpeQJE0HZKoJoEQLaOzLYq8N9ue-5OUYcEgdYA6h5K4zKUY4JTykBzMMqMsHmAjIZiVQ7EvhB6PmnXv8EZjBJNsb7fa9_rFThBZKZiBgiSzU5yGFwkWYCM0gwsCnSJyoiWojSnCQgkRKswlIghvKNdbBO3xxMOe8StOLvTfzWwddEerBIMgnjd-7Ad--r3yp6HBzVC8-KKJH5A7CCgFKU6GAuUMaxlbph8ofksEqdOcPESlyZbFENrs32m1azlIvXbMLUrYKW_qaJe37ac39BDzgD2I993_8BULelajf44OslpWBnFuxsA9X_cLZG9X0LdtqAnRpY34KdNGAnBhZYsOMG7NjABhYsbMBCAzuyYEcN2JGBhRZs0IANDOzYggUNWGBgJxvh3YT1DczOwibKYKwUeJuqfCsFgZUCL2jATAoCKwXeoAEzKQisFHhHDZhJQWClwAsbMJOCwEqBd9yAmRQEVgq8kwbMpCCwUuCdNmAmBYGVAu-sAevrs-rVrTh7pN-cOS3MJhS0IPbuG2ZZl11fXxrb-y-0vAgtbiZqoeVA37fXhtmeobWAAhsTWBhrAYU2JjSYY2v1KNcMSP3tiNW9uVUjhgsKB3e8fbNeM5rI2LpZPwuc36mPc4F5zFJ9MN_vjtnGxQMXRVEps_L0Zjf37Ocbo6QyFPGv8iBmWuB_UA70XCQFnen0bK_tBqthTqUdwSYnpOcbjGLJ4DqKV22UUK28EyFdXDiquHAKzBy4fy1a6AkztMRRgtJsFVl1SG2yY9Ba9bSwnWDxX5VX-4nd7I_eUvv6D_m1qWmh-LkW2LUXhrGQULpuYzpye1W-hdQXKTy68Lig8VfnAmo-ixOVUDwuIj0XqXqwI5ctudbA7LafksNtb8i02FXmHLqwgjaFfiutUlmzMOq-f-Xs1dH1gPgCe1crwslPsAmT9d_es5WCVKQqf1YG5tDTtSnfle32SnQmGCcb6d3RIXVO8-7u6kBq-ppv8lq7bozoQufQyDXEWzdBTHPQsCuZaTV36BW5Jdc1QvOyyduKiGr-Dg1D1TC2Hd7OiHL7Iq5vKn3gxnTrhnv1Et4SbDEO45mK-zVLY9vpjfGuxpvK9hmuykPA0gX4f4XYMiUWgbquKvR8lOv5BhG462JMtsuynbId-cwEEtI6h9f1XT1-SE1Yy3QxrHVumRXl6AFGK4lOJtFyh6eiHD3EJGo7fW4xSSgztsp_Z4Lyjt491Qq2rainHrXky5ce6EGe9T90zz03hXaDX2N2rQdC6HQ4tCsfV6qNa6va7kuwalYArt4YYWTJqCy0fP1TzavnL8nFjLKamBrIRGqNvID_KItlhlTrlGMB-4SXsnBUFdC_cErgohTA9VmBaUbZVGZV61g2WaMuNRPHMSXVe-eoveGoW1u_F_hAhsLGQqBTLZXxdDSezIefxtHF58vL8XQ8GY2jj-P5b-PxxK0oAo4tH94FA7_nBGEIn4H_vp6EWFa5ZfSb2_5IqFbNv-6pejGxvPw0HQ_n42k0nFxoN6PK7aiaaDqqfTzy9ecNHd3De5ebe-Pyho76R_rz_Y7qx1hSk1dd4fng5W_uxgwH',
                },
                {
                    type: 'single',
                    icon: 'mdi-calendar-month',
                    title: 'Monthly sales forecast',
                    link: '/reports/measures/sales_forecast?dimension=by_variant&report_query=eJzlWltv2zYU_iuCnlYgD02CvvitTRAs6dpkcLqhCAqBlmibCEVqvDgVgvz3kRRliZE8SyXVAtpLUZ3r9x1eco6l51gggWG8iJcAQx5dUQZTwEV8EqdbwMR9WWiletwCfqEl8UIwCU9ivqVPVrAGmGsJxDAVMLsALLugWOaEx4uH55iAXMf4CzAEiIiuc7CBOj7NtBjZxwwIYLPVIiwR_wSKApFNSwqkoEuTap85pZiya5LB7w0YygRYaWYa7svJHsYdo5lMRQPgWsD8Qf8TXUKeMlQIRMk3F5GA30UH0KpMin0wT1S2OA2q3V5wDEZj6Ylh-fFLk98yS_ijHIDBtQ5Ti-g665QjQZmLhsh8BdmhmlTmgeDcmo0RnXZBUaM5Hb5WLY-w4M4OgTsbDe4sOLjzQ-DOR4M79wf3ATADprPjV3vF0F3feHhi-kKQiC4o794DiVSqJK1ULVypZAyStDxYr7af7_0AMVbBozuG0lbdTIbCyoZAcxw8Md0ytEEE4NegqJWPAtZx8gT3N0SbbWstBRUq-FMtPX6NvXIIAifSm6zBVAU322TAjnetPfH8vlR7vX0CtzwZePIaS08MF1QSwcqIrqNqKzVo0kqV0HVCa9UxXH0-ngivyQ4SQRXGewbSR52n6Z0qnSgT0eiOYex18i4jEYhIGHF7RzxtIYmoFLqwXND0sV3XyjaxtokyS2qb4wX-D-cwnaHTd9RX_MC-wzEPBMdk7AASlXR4j1p7-P5NhySjrMFTPUeftXYQnF0dIFB5lgIIyXsa11o-okR7n1BLBzY9yEQlHbN0IMgZxdpXdU89mFJHObTxcb18iyZXGPEtzKJLIHp2fFHrk6zSt1BaST_KjqMn0CvTcHTn5QruA9eKZG0VrwbJDKZqjsUdrK5TAIw2koX5p1S9IBJldAcZoq377UGgHCaFkSYF2lF1CBwoiQZSTfaJzjFkMB4b05_u-x1kYANfsW3RBLuNBfGPVQ5cmK5jqEZMbfSDe-jJWvwY5gPeASYAg_cPva--QsA6mx7rxS2VZtSu33v5A9SocGnreq-6_KyDUWjpKHzCxglSPAOqb8n3h2M8zD7XEOMe4FTfdH13nNVVGYdW03HyB3j29uxddANI9Jt7vbwZc71VQmWRNOFy1WRu3wwj5ZmhXQL7u-qeruH_mu8VXIXka8JNytfNMJrvJ8BC8jXhJuXrZhjN930RlK8JNylfN8MPrG8Zdn3Lyde39OF7I8PeV3Ly-0p63Vc3Eofliyfni73Or9wEPb863LTn18kwmu8SFiH5mnCT8nUzjOZ7q8b6gHxNuEn5uhlG8_1MdyH5mnCT8nUzjOZ7CdOQfE24Sfm6GY7z_XYS56oRlwz2_eyQqeyEI0rsj3XNW2i4BhKLhAGy0Z5KtEZYQBYvHlTIClT1ci7Wr3iUPSJQjyEFYCDnlVn9iUDCYKFw6R-QftpnAr_gG4DJX_D_lLf3Mx-5Zj5hzXygmvn8NPNxaebT0cyHoZnPPjMfdWY-2cx8kPk_zi2F6uztjKFGhmfzHC9OT2KkOnd-B9mdEbx7W3l_KO3Qof6v23r1ZEIp0YZRWdR682AN9HQkuVjS1nfNuZp7UEvyosoKcCox0JNMDgVDqZ1vUpqrcQdxSqp3zYvnFz0bkepzaPOxUbw4f_kXWygOvQ',
                },
                {
                    type: 'single',
                    icon: 'mdi-package-variant',
                    title: 'Forecasting for bundles',
                    link: '/reports/38/bundles-demand-forecasting/609?report_query=eJztWW1v2zYQ_iuCgAEbbBW2EtuJv6XJBgxr16xOAwxBIDAS7XClRFWkPAtB_vuOlG2eaNmzHSxDgXwJIvK5e-6F4p3OT75iilN_7P-azWmmRFF5n2nOacbkYwoLftePH0mhbqpco-DxkchLveKPVVHSri8fxd_LhSnhUq9QTmNFk0tSJJeCl2km_fHdk5-RVOu4LkRSxkazSAy1oumd_uNdURkXLFdMZPewnxBFlsSKLrQEL5n8SPKcZTNYfKiifKnsubvWf0sKRjKkf75e-DeFKyTSNvnti9W0ZIvk1_Ig84wAUvqZiiKhhfdHCWxMVZbhjq3yEBU4D044EhqzlPANyi3SbdxXRFHEW9TLEZBQl6xGNpkwHqv_kjElvYngCVIu4TH6tnQ2yklB0j0dapHcZNMgLwefEoJDSea0IDMKJjJeRaWGRkbfIQbsVoJtuUj-KiUce688yihJOJWRKmiWvNQ0pAob-IGSxLthKfV-BJvkT8gqODWJKCIOiEgBYk8LXLHGi0OmVFXeRIn4Kz4KZjmSehkE55TvexI2BNtO9bVg-NVfH-tcr-_J1JDBJPaObHlxL2JVEu5tYvZk3SrftCAWKeDbb456L7KXwLfDTNihARtxBYfHE1MPl4yUsEwrQYk2idIHDanLOck0bt-c79KBTfoI7GmZtkXPWgSuHR-bduGGDWSxhw1k8QIbWoXb4mDeOu9SzM1FX0knCnVcY71tontADFzRtgjsYgcXjmVvEW3z_dO20qrNr9_sI3LfFGzzejsvGH4c74Yg5v2FLaDYbGWd6u3jeNtE2y7byyrmbT1ErNcPvGyNjFva4QxJfJuvKp6udXAKpHujx2UBRS-utpbKtaD_fN_1U0pkWdAdfRNoh7KWSWhI64bO9pJSQc9bV72xH_bC06B3HoQj2IGi2Fjvh0E41KrolJRcRQXJZnrzJIXFKeOKFrg_th2U91B578ssgWq-tZl6MPs6DnPCSwDc-T0ffBPQehDwCCRmqj0VOgQ5mwsVCdNy1_296WsaDfsEOnzvRuTWBiXyDDNecK45zfOSRELgzeFo6ZKZVLcaWrOwxB8Phl3_A3mAmj72BwC5rTXD__pEGMTIIvo9BIGHNebMYkKMCRHmHDFhzMBihj2L0a5ZkH7SYeOCJOZkmU8edGp_XsS81FueKFUgpoG5sbykcQvCViSmEapudCWGo5qJlwV12Ldu_C6QF6B47WpoMX-aY7YCVfC009V1v3tjGs21d7j7RN70XWe0xU1XsjJ9gHeh1RmU2k6_1_sBZ_edTR3Kbue8geq_O1-j-ijBnTMHdmZhKICdkQMbWRiKYWfowIYWdoJgAwdmD3r_FMFOHdiphQ0Q7MSBnVgYerE6oQMLLWzUCG8T1rcwnIUmymJQCoKmqh5KQYhSEIQOzKYgRCkIThyYTUGIUhCcOjCbghClIBg4MJuCEKUgGDowm4IQpSAYOTCbghClIDhzYDYFIUpBcO7A-m2v4r0dteiyJQpd2r7zccv_ORlpFt6JuWtx4cVf2GZzT-oNue2k-1f7g2cntSimXpKZScX2YQ30Zq2srRndJvs2IfouJkRvA47lJbQcZ2wOyl51qvG6I7TXHQ--ysDubSz0NhZ6Gwv9t2MhPUTQNaaeIUDr-WSe4UOg6zPoMuU1La7NwgBafgld6vtKfw9u7-fua5juTgGof2WElVkhytxIrh6W-3qOA1V1ItAvkGnJFUMrz1370x2daZZIt9xgT0x4XHKiW-iUqoLFslYJdQLKN5Miq3_hGj89P_8DSs_0ZA',
                },
                {
                    type: 'single',
                    icon: 'mdi-chart-timeline-variant',
                    title: 'Inventory burndown',
                    link: '/reports/measures/inventory_burndown?report_query=eJzVWm1v2zYQ_iuCgAEtFhe2EufF2JcmbbdsS5vFaYvBCARaYhyutKhSZFIjyH8fXySRenEsR_SHfkmr43PH53gUeXfyo88Qw9Cf-OfJPUwYoSvvlNMkJg-Jv-dHd4Cy61UqAafnv4cfP1-cvr8SA3cgO5Nj_oRRDvf8GGUpBqsLEksoA3Nhc8_PIIYRg_EZoPEZwXyZZP5k9ugnYClhl5TEPGLe-RIsJDzS2ih_jAED-dyFCHOUXYA0RcnCkgLOyFRN5U9uAc6gNIUJPU9i-KMUZYRqXory016dhiFwzuByJv9472AWUZQyRJKbKiMGf7AGofkqTEtjPVl9ARSBxGJ1Xwo20TDInhymf3028-eehdk3vtVS5ApulsM7jxsrEqK4Sijhyzmk65ZFwx3R-aT2hjdqkiJqZNQ9XJaGW3LBOnLB1uQC5-T215Hb35rcfn9yp4AqMo1NPy8HNnFqavTk9DlBzDsjmXUUcCEKIy2y-EScUphEqwYnG9_3SIAYC6PeJUURrDFKc1lnSoVCT06fKFqgBOA6KZLLtyLWUOpJ7itEizsrdowwYfyhkG4-tmoKTuh4clMZTtp4yLVw0w6vonvy-WMq9rb9xt1lYcc3zSB7cjgjPGEi8SG3nt5Khk2kh0JyG5JiaBOvNp2eDE1ydk1B9E3OY9IlPcZWITNjmzi2KvVexoShhEMvy8-IhzuYeIQzubAZI9E3e101NsyxoYCFBWbzAj-j7CYZrOQZxZHeMc-owB3RUTM2CDEt3SIXyzX63uFQFAjU8NHP3kc52onOfWGg723E0xQjaFHJjGQTDwvqKEpTBhjPWlLmQr5N1lzouNpBYNHCjGnpNjsIODkqsNQVSVsLp6gy2DXfqmr1XTQ-xyi7g7H3DrCWFy8txsNYj1ssc0k7y4ais4vhHy4yYcRWhuzsbcS4yIqamFotG8NIlNK4QXqtfn_eHwiFEchYi3HvElJErON3xtAShqmShim6J-JoLbRCyUO3GUI5RZcqfQtzbrL3zJsSHHvzlTcVDDC09vxMZlFZmInxMFODHWPT0HNN9ZQncZWqmux7HqVwrsY7sm1TdVCtaYqetL6Wpwh0O9f2O2GNbn-yH6HOuvUKr6cLKFi-aFWVpoNiirMBuR2odEqcfit7B8g8S2S1akwcYKusI9GGnouDr50iSranV9Fx9R7J4HhiA3nCqMUP3EMKFlBMhfAqtN7ibQL_vJH-HryN_-MZE7cff5ErGRBvpTg_RZLX1yHLlIs9E5GlLExa7kqUj1l3wfftbstnLLi8578AzK2MpHnJy1ZRjfLaZkercn-2V5CJQDao2uKuDGum3PfSym1cNsm6Umso7qy7NqvIu_KrG9tRl21W7Zh1Zee6z1bUOeLfWxHkC0ArjZxZmYGr8XCpxmtkxRkXwWR9jVHR7U9ZXl2yN2Jevyu4BCiptHdm5mqyTpYUg0TiumYKz9no70gwDA68dzDyXpXWX3fM3_WzTLSMkQuSsLvX3Tx7uXHbZ_0R03ZZS4zHagmqLo-9P0HS1-XcyG5crht_ics3e_4SgoxTq9dIZQ5ffiSOBZ0kE4V33tspvz5mDFBRR6FyjwxGw0FwLEbEdW7Jx4PhwSAYS1PwFnDMQgqShRwcHQ_lvX-LMIO07dPxxo7Lvbo4JjN51aF76At3iFgdIJwQcPi9pSbo03ctp_v3_bTTXAKjQ6a_YanKTqwCSqB0XOVzlW_mZeF8LZbPeyVfaWvf3eajenEtOmIhJR31nM9flo2tHU0CYrXb6vu-TA2v85ys6LtVEjUzb31WjOpfrcycYkjd89phFPuT4z3_bzCHWMB-HQ2HvwiUzgTEvnkzVJGSsBMLdlJBjd6clKjR0IId12DHBjayYEc12JGBBRbssAY7NLB9CzauwcYGdmDBDmqwAwMbW7D9GmzfwA4tWFCDBQZ2VFneKmxkYHYUqiiDsUIwqJoaWiEIrBAMghrMhCCwQjDYr8FMCAIrBIODGsyEILBCMBjXYCYEgRWCwWENZkIQWCEYHNVgJgSBFYLBcQ1mQhBYIRic1GAjdTysfRV1n6z-aUBfC3mfv3wPl_IK6HICFF2R5rt4aHn0FcJvFtUH-Vi4dGi5pG4eC6hptHh1Y34sFFKYijtINnR384OhXf_0x-2PeOyuucqlrZ7pc2Wgs17vz53n_dwpW539Bzjvz14Z2RX7qnEHObYo5Pq7rIzsyuWqcQcuv00duKyM7MrlqnEnUV65iPJql1FeOS4euYuTiO_yJOJ9i8eGy9iFy3iXLmPH7zJfOHiXpZGdvcsV4w5cnsK0v8vKyK5crhp34PInkZT2dlkZ2ZXLVeMvbASlst2tGxUiL39Uz6L22_ORyJgzUY9cKsF4qLVPV7L0WJNS32iMlAmUmkKIFpTwVOkVDzlAtqF4xqaEmhblkmOGLMmTcAPgiGMgy4glZBRFmdaNyDIVCXVGEv3Di8njU-7zFcd5kaMLjjMdOIBxWYGUddSo0tD5zc9NiP_TxfxVMB7vecHwQP15XQyKUOVh1HWNv6GfpjtCyVlOhosSYLL_9D8a-iPM',
                },
                {
                    type: 'single',
                    icon: 'mdi-transfer',
                    title: 'Inventory movement-based',
                    link: '/reports/38/inventory-movement-based-forecasting/661?report_query=eJytV21v6jYU%2FiuRpUmbRq6SAIXyre3dpGqrbjdopQlVkRsb6l0nzmyHDVX89x0nATsmVLDdL4gcP%2BfF57HPOX5HmmlO0QzdFxtaaCG3wYPY0Bz%2Bh7dYURL8LCTNsNKsWAcrIYNHKUiV6eAZS4YLjQYoe8NSL7alMTN%2Feni4%2Bf0PkL5hdWcW0EzLig6QehN%2Ft4IV5spIKKeZpuQOS3IneJUXCs2W76jAuTHlOBDECDYHAcEatw41%2FcdIeMXUAy5LiBLNiorz3eBgaL%2BDYI45VcFvFRhhemsNL1ctIlUGkf7VIl66rgjNWI657w2d0EZOCAuhMQ%2BeCqZVMBecOL4rI0wVCFO25yAtOS4KsH5mBB%2FaQLuXAcopVpU0NixgZZlNlRbZ1zRvqTdeGfxRTBSg8rpNbe6VBg5Tzep9JVEyCqNJGE9hhRakI4%2BjMJ4YU3SFK65TiYu1WRzmIFwxrqkEviG4km2ETkWpG3ewWmKJ885pOJC4AA%2FB9wRv1Q82iwcKav8DOCq8AvkSDSP00n62OVSwXU67eS2q%2FBWCgc0Jqb9IYgJDcRSZRAtM6iTXh9ah9Ib8WSk4vcFCwsZtKM0h0K3wEEjsx8GZ0ieiMEvPBtpkgBE0mw7Qr%2FiVcoD9CIF9B6jnxjRKPkX1UTOwawd23UHFn64PqDhyYFMPNrWw2IFNPNjEwhIHduXBrixs6MDGHmxsYSMHNvJgIwsbO7ChBxta2JUDSzxYYmGTTnq7sNjCXBa6KItxKAi7piKHgsShIEw8mKUgcSgIhx7MUpA4FIQjD2YpSBwKwrEHsxQkDgXhlQezFCQOBeHEg1kKEoeCcOrBLAWJQ0F47cHiuoa5l3PUczdfbEtJJS0BnWbHbWXfv%2B5zvKb22rL607nfLc4i7jXNl%2BYn%2BExVJlldrrwC3deNTPksW2OO%2FW%2FW3ua%2FPFkjraNUfa0uiqxW6OuZi6agHnVKU2i9zdv61d8e69rc58POHj29%2BZx%2BdWabPKv1OQHe0jWrW2hfXK%2F7xUvHhWPFU5PCZ2qooe60QFqR0%2BcvdP%2BBhVNx3BDSCQKb7%2F8ewSl11%2F1PBTmRd1qvXOjTuzLd9AYllQEMFO4ON1RCPUgJZnybNuPVPnHn7vIDE6hvjvhfQaXO2PENAnTNucHu%2BQi%2BFOEbdsee5U2mKzgxx3f5zHBO6rv%2B74tM5OZgHGCdStEsXnoej%2FQ6ZRoyIORxgd3s5RfU2FbHO4jBnVBOG6gfBNC4lF%2FVskoCHdm2d%2FqvFXraV6CN8lH0rfSC2GuNHvvwHNCV6mlAe%2FklPajRMY28NCezeRFA936vv2G4GiAGDVg9UvlYC8ZRMxbcbs2MfWavaEcJ08VBy7xOQbKWoiprM%2FuPdt08nuCCzoXzcs3hOcMcyW5g903XxktqZhoILsM8qzg2VyqnWrJMNSbhxMEbhylRwP3TsJP33e5fTcYtcQ%3D%3D',
                },
            ],
            icon: 'mdi-chart-timeline-variant',
            permissionRequired: true,
            permissionCode: FEATURES.DEMAND_FORECASTING,
          },
          {
            section: 'reorder-suggestion',
            title: 'Reorder suggestion',
            icon: 'mdi-cart-arrow-up',
            type: 'group',
            items: [
              {
                title: 'Buying calendar',
                icon: 'mdi-calendar-month',
                type: 'single',
                link: '/buying-calendar',
              },
              {
                title: 'Buying table',
                icon: 'mdi-table',
                type: 'single',
                link: '/buying-table',
              },
              {
                title: 'Transfer suggestions',
                icon: 'mdi-swap-horizontal',
                type: 'single',
                link: '/inventory-transfers/suggestions',
              },
            ],
          },
          {
            section: 'purchase-order',
            title: 'Purchase order',
            icon: 'mdi-file-document-outline',
            type: 'group',
            items: [
              {
                title: 'Automated PO Overview',
                icon: 'mdi-information-outline',
                type: 'single',
                link: '/automated-po-overview',
                permissionRequired: true,
                permissionCode: FEATURES.AUTOMATED_PURCHASE_ORDER,
              },
              {
                title: 'Purchase order',
                icon: 'mdi-file-document',
                type: 'single',
                link: '/purchase-orders',
              },
              {
                title: 'Unapproved POs',
                icon: 'mdi-file-clock',
                type: 'single',
                link: '/purchase-orders/unapproved',
                permissionRequired: true,
                permissionCode: FEATURES.AUTOMATED_PURCHASE_ORDER,
              },
              {
                title: 'Automation Dashboard',
                icon: 'mdi-chart-box-outline',
                type: 'single',
                link: '/automation-dashboard',
                permissionRequired: true,
                permissionCode: FEATURES.AUTOMATED_PURCHASE_ORDER,
              },
              {
                title: 'Automation Config',
                icon: 'mdi-cogs',
                type: 'single',
                link: '/automation-configs',
                permissionRequired: true,
                permissionCode: FEATURES.AUTOMATED_PURCHASE_ORDER,
              },
            ],
          },
          {
            section: 'supplier-management',
            title: 'Supplier management',
            icon: 'mdi-truck',
            type: 'group',
            items: [
              {
                title: 'Supplier list',
                icon: 'mdi-truck',
                type: 'single',
                link: '/suppliers',
              },
            ],
          },
          {
            section: 'inventory-tracking',
            title: 'Inventory status',
            icon: 'mdi-cube-outline',
            type: 'group',
            items: [
              {
                title: 'Inventory tracking overview',
                icon: 'mdi-view-grid-plus',
                type: 'single',
                link: '/board/1460',
              },
              {
                title: 'Inventory performance',
                icon: 'mdi-chart-box-outline',
                type: 'single',
                link: '/board/2333',
              },
              {
                title: 'Inventory on-hand',
                icon: 'mdi-package-variant-closed',
                type: 'single',
                link: '/reports/31',
              },
              {
                title: 'Inventory remaining days',
                icon: 'mdi-calendar-clock',
                type: 'single',
                link: '/reports/212',
              },
              {
                title: 'Replenish from warehouse',
                icon: 'mdi-package-variant-closed',
                link: '/reports/measures/inventory_transfer_suggestion?report_query=eJztWMlu2zAQ%2FRVBpwbwoT304lvjokDQBW6W9hAEwoQay0QoUeDi1jD87x1SlE3Hm6wcetHFEGf43jxRM9KDV6nhRmA6Tn%2BDwrm0GpNbrAVWXM9LrAytmCzpKgfDZaXTUcrmoMz9snYoWs5BT1wkHRtlcZTqufwTAjMQ2kVQIDOYT0DlEylsSTTjx1VaQek4pkrmlhnHLHMXuDFYPrqf5DNqpnjtKj9RnjRAKGzwr0MIy%2FV3qGteFRR8XmZ1IFuPNvy%2FQHGoIv7FJnCOsN0Zsd19fdgyhWqZfrEd2OLdEeM1KE%2B3x%2Fq8SXRlbhERezjd5M6AsfqA9Dbe%2FXBbzIEqnmCvhmmiF1TwiPgZUgNKtWVu1skPl%2B1EvGgIIsqHiptkIvV%2BY2SWUhlrUhE3s0phxZbH2iTCxQ2DQtC2ZKo4i87G761DrEuRCBCx38vkm2R%2BNtvTCAUejcxESGVud5cJeo2JS31aABfwLDD5aeluuVkm76LyV0dKNzdkMl7RMzBSLV%2FpyJHxEsRJKXscsa6bit5Q7oQvksUD6k269kliYV%2BkQgaaZg8E6k6qZgGSaQfpoWiXYLffc1TaSPaCeeKav5si62C%2Bs%2FvIidCxllssgVfumfVUpVqC3speMew8NyXLo1M1o%2BTlc7WPOjdZOyKujgroO11nWM7MV0dxvWfsHM2pKeuordeknaLYeSsrqPQMlfIPNbR1R2EmYB30ou4%2BR3N4AN8itd8UnuQ4dIqNqvhNEBKXDf8OKF0%2FjdISQVvlQJvO2pxbpm1RoHYaHT8nC6zddeMmtg4SZ2CFyQhVBEM848KgIodLFWq%2BkCaT3sH6bzjt5xXmtK0GBaVutrUOmU6jlsp5iMElDy55cMmDSx5c8uCSB5c8uOTBJQ8u%2BT%2B55BoKDBaWHOnKr9Pxh1HKyXzqKaqpD3x8Tz6WzOv1MnhaunbOlFb%2Bf2AKFUraus37RdjgvLjV5k5G%2FxqXZKt5FFmPtm4Mi9IPYp6OqSoDwawA559LNPTtD66a5oFMNtd0fnTnJHG1Xv8DZjwqYA%3D%3D',
              },
            ],
          },
          {
            section: 'analytics',
            title: 'Analytics',
            icon: 'mdi-chart-box',
            items: [
              {
                title: 'AI Report Builder (beta)',
                icon: 'mdi-brain',
                type: 'single',
                link: '/assistant/ai-report-builder',
                permissionRequired: true,
                permissionCode: FEATURES.PAID_MEASURES,
                lockInfo: {
                    requiredPackage: 'Replenishment',
                    benefits: [
                        'Build tailored inventory and sales reports using AI',
                        'Automate complex data analysis and reporting',
                        'Empower decision-making with AI-driven recommendations',
                        'Save time on manual data analysis'
                    ],
                    tooltipText: 'Build tailored inventory and sales reports using AI'
                } as LockInfo,
              },
              {
                title: 'Browse Reports',
                icon: 'mdi-bookshelf',
                type: 'single',
                link: '/report-library',
              },
            ],
          },

          {
            section: 'report-scheduling',
            title: 'Report Scheduling',
            icon: 'mdi-bell-ring',
            permissionRequired: true,
            permissionCode: FEATURES.SCHEDULE_MANAGEMENT,
            items: [
              {
                title: 'Scheduled reports',
                link: '/schedules',
                icon: 'mdi-calendar-clock',
              },
              {
                title: 'Schedule profiles',
                link: '/schedule/profiles',
                icon: 'mdi-account-clock',
              },
              {
                title: 'Schedule templates',
                link: '/schedule/templates',
                icon: 'mdi-file-document-outline',
              },
              {
                title: 'Email templates',
                link: '/email-templates',
                icon: 'mdi-email-outline',
              },
              {
                title: 'Email receivers',
                link: '/email-receivers',
                icon: 'mdi-account-group',
              },
            ],
          },
          {
            section: 'product-segmentation',
            title: 'Product Segmentation',
            icon: 'mdi-segment',
            permissionRequired: true,
            permissionCode: FEATURES.PRODUCT_SEGMENTATION,
            items: [
              {
                title: 'Product segment listing',
                link: '/product-segment',
                icon: 'mdi-view-list',
              },
              {
                title: 'Product segment builder',
                link: '/product/explore',
                icon: 'mdi-view-grid',
              },
            ],
          },
          {
            section: 'integrations',
            title: 'Integrations',
            icon: 'mdi-link',
            items: [
              {
                title: 'Google Sheets',
                icon: 'mdi-google-spreadsheet',
                type: 'group',
                permissionRequired: true,
                permissionCode: FEATURES.BASIC_SPREADSHEET_INTEGRATION,
                items: [
                  {
                    title: 'Google spreadsheets Introduction',
                    link: '/google-spreadsheet-introduction',
                  },
                  {
                    title: 'Google spreadsheets templates',
                    link: '/google-spreadsheet-templates',
                  },
                  {
                    title: 'Google spreadsheets files',
                    link: '/google-spreadsheet-files',
                  },
                ],
              },
              {
                title: 'QuickBooks',
                icon: 'qb',
                type: 'group',
                permissionRequired: true,
                permissionCode: FEATURES.QUICKBOOKS_INTEGRATION,
                items: [
                  {
                    title: 'Introduction',
                    link: '/quickbooks-integration',
                  },
                  {
                    title: 'Configuration',
                    link: '/settings/incoming-inventory',
                  },
                ],
              },
            ],
          },
          {
            section: 'my-account',
            title: 'My account',
            icon: 'mdi-account',
            items: [
              {
                title: 'My subscription',
                link: '/subscription',
                icon: 'mdi-credit-card-outline',
              },
              {
                title: 'My reports',
                icon: 'mdi-chart-timeline-variant',
                type: 'single',
                link: '/my-reports',
              },
              {
                title: 'My dashboards',
                icon: 'mdi-chart-box-outline',
                type: 'single',
                link: '/my-dashboards',
              },
              {
                title: 'User Management',
                icon: 'mdi-account-group',
                type: 'single',
                link: '/users',
              },
              {
                title: 'Recently downloaded files',
                icon: 'mdi-download',
                type: 'single',
                link: '/download-manager',
              },
              {
                title: 'Importing status',
                link: '/importing-status',
                icon: 'mdi-database-import',
              },
              {
                title: 'Logout',
                link: '/logout',
                icon: 'mdi-logout',
              },
            ],
          },
          {
            title: 'Settings',
            icon: 'mdi-cog',
            type: 'group',
            items: [
              {
                title: 'Store contact',
                link: '/settings/contact',
                icon: 'mdi-contacts',
              },
              {
                title: 'Reorder parameters',
                icon: 'mdi-refresh-auto',
                type: 'single',
                link: '/settings/reorder-parameters',
              },
              {
                title: 'Incoming inventory',
                link: '/settings/incoming-inventory',
                icon: 'mdi-package-variant-plus',
                permissionRequired: true,
                permissionCode: FEATURES.INCOMING_INVENTORY,
              },
              {
                title: 'Internal inventory transfer settings',
                link: '/settings/internal-inventory-transfer-settings',
                icon: 'mdi-transfer',
                permissionRequired: true,
                permissionCode: FEATURES.REPLENISH_FROM_WAREHOUSE,
              },
              {
                title: 'Inventory forecast settings',
                link: '/settings/inventory-forecast',
                icon: 'mdi-chart-line',
                permissionRequired: true,
                permissionCode: FEATURES.DEMAND_FORECASTING,
              },
              {
                title: 'Bundle product mapping',
                link: '/settings/bundle-product-mapping',
                icon: 'mdi-group',
                permissionRequired: true,
                permissionCode: FEATURES.BUNDLE_PRODUCT_MAPPING,
              },
              {
                title: 'Multi-store settings',
                link: '/settings/multi-store-settings',
                icon: 'mdi-storefront-plus-outline',
                permissionRequired: true,
                permissionCode: FEATURES.MULTI_STORE,
              },
              {
                title: 'Location restrictions',
                link: '/settings/location-restrictions',
                icon: 'mdi-map-marker-off',
              },
            ],
          },
        ],
};
